export default "__VITE_ASSET__CRCmxs0N__"